import React from 'react';

import { SORT_DIRECTIONS } from 'app/shared/componentsRestyled/common/TooltipedSortLabel';
import dayjs from 'dayjs';
import _ from 'lodash';

import { ValueStub } from 'constants/data';
import { COMMON_DATE_FORMAT } from 'constants/date';
import { DocumentExpirationDateType } from 'constants/loanApplication';
import { PendingChangesActionType } from 'constants/pendingChanges';
import { prepareStringForComparison } from 'utils/data';
import { parseCalendarDate } from 'utils/date';

import DocumentExpirationDateForm from './DocumentExpirationDateForm';
import { titleCellStyles } from './DocumentExpirationDateForm/DocumentExpirationDateForm.styles';
import {
  cellsCount,
  tableCellDateTypes,
  TableCellId,
  tableCellNumberTypes,
} from './DocumentExpirationDates.constants';

const getEditableRowFields = ({ dataToEdit, setDataToEdit }) => {
  const { id } = dataToEdit || {};
  const isNewRecord = !id;
  const isAdded =
    isNewRecord || dataToEdit?.pendingChangesActionType === PendingChangesActionType.ADDED;

  return {
    ...dataToEdit,
    modifiedFields: [],
    pendingChangesActionType: isAdded
      ? PendingChangesActionType.ADDED
      : dataToEdit.pendingChangesActionType,
    [TableCellId.TITLE]: {
      colSpan: cellsCount,
      content: <DocumentExpirationDateForm dataToEdit={dataToEdit} setDataToEdit={setDataToEdit} />,
      customStyles: titleCellStyles,
    },
  };
};

export const processData = ({ data, order, dataToEdit, setDataToEdit }) => {
  const orderedData = _.orderBy(
    data,
    [
      item => {
        const isDate = tableCellDateTypes.includes(order.id);
        const isNumber = tableCellNumberTypes.includes(order.id);

        if (isDate) {
          const date = dayjs(item[order.id]);

          return date?.isValid() ? date.valueOf() : item[order.id];
        }

        if (isNumber) {
          return Number(item[order.id]);
        }

        return prepareStringForComparison(item[order.id]);
      },
      item => prepareStringForComparison(item[TableCellId.TITLE]),
    ],
    [order.direction, SORT_DIRECTIONS.ASC],
  );

  const isNewRecord = !!dataToEdit && !dataToEdit.id;
  const isRecordToEdit = !!dataToEdit?.id;

  if (isNewRecord) {
    const editableRow = getEditableRowFields({ dataToEdit, setDataToEdit });

    return [editableRow, ...orderedData];
  }

  if (isRecordToEdit) {
    const editableRow = getEditableRowFields({ dataToEdit, setDataToEdit });
    const rowIndexToReplace = orderedData.findIndex(item => item.id === dataToEdit.id);

    if (rowIndexToReplace === -1) {
      return [editableRow, ...orderedData];
    }

    return [
      ...orderedData.slice(0, rowIndexToReplace),
      editableRow,
      ...orderedData.slice(rowIndexToReplace + 1),
    ];
  }

  return orderedData;
};

export const checkIsDefaultDocumentExpirationDate = documentExpirationDateType =>
  !!documentExpirationDateType && documentExpirationDateType !== DocumentExpirationDateType.OTHER;

export const renderDateCellContent = cellData =>
  cellData ? parseCalendarDate(cellData).format(COMMON_DATE_FORMAT) : ValueStub.ALTERNATE;
